import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { BeketPassengersValue } from 'entities/beket/models/form-passengers'

import { TariffBeket } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { ListBlock } from 'shared/ui/list-block'

import s from './styles.module.scss'

interface Props {
  title: string
  subtitle?: string
  isChild?: boolean
  passenger: BeketPassengersValue | null
}

const childInfo = [
  // {
  //   label: 'birth_day',
  //   value: 'dateOfBirth',
  // },
  {
    label: 'beket.tariff',
    value: 'tariff',
  },
]

export const BeketRenderPassengerInfo: FC<Props> = ({
  passenger,
  isChild,
  title,
  subtitle,
}) => {
  const { t } = useTranslation()

  const baseList = [
    {
      label: t('last_name'),
      value: passenger?.lastName,
    },
    {
      label: t('first_name'),
      value: passenger?.firstName,
    },
  ]

  if (passenger?.citizenship) {
    baseList.push({
      label: t('citizenship'),
      value: passenger?.citizenship,
    })
  }

  if (passenger?.serialDocuments) {
    baseList.push({
      label: t('serial_documents'),
      value: passenger?.serialDocuments,
    })
  }

  const prepareChildList = () => {
    return childInfo.forEach((item) => {
      const preparedItem = item.value as keyof BeketPassengersValue

      switch (item.value) {
        case 'dateOfBirth':
          baseList.push({
            label: t(item.label),
            value: dateFormat(
              passenger![preparedItem]!,
              DATE_FORMAT_LIST.FULL_DATE,
            ),
          })
          return
        case 'tariff':
          if (passenger?.tariff === TariffBeket.child.key) {
            baseList.push({
              label: t(item.label),
              value: t('beket.tariff_child'),
            })
          }

          return
      }
    })
  }

  if (isChild && passenger?.tariff === TariffBeket.child.key) {
    prepareChildList()
  }

  return (
    <div className={s.container}>
      <ListBlock
        title={title}
        list={baseList}
        subtitle={subtitle}
      />
    </div>
  )
}
